module.exports = __webpack_public_path__ + "img/icon-legacy-lab-manager.5654eaa6.svg";